import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Breadcrumb, Card, Col, Form, Row } from 'antd';
import { AppWrappperHOC } from '../Root/HOC';
import Container from '../../components/Container';
import { ZaggleCard } from '../NetworkCards/StyledNetworkCard';
import { constants, utils } from '../../devUtils';
import { StyledIndusindMinKyc } from './StyledIndusIndMinkyc';
import PersonalAddressForm from './PersonalAddressForm';
import { IndusindMinKycDispatchToProps, IndusindMinKycProps, IndusindMinKycmapStateToProps } from './IndusindMinKycDataHandler';


class IndusindMinKyc extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formValues: {
        personalDetails: {},
      },
    };
  }

  componentDidMount() {
    const { onInitGetMinKycUserDetails } = this.props;
    onInitGetMinKycUserDetails();
  }

  componentWillReceiveProps(nextProps) {
    const {
      IndusindMinKycUserInfo: _IndusindMinKycUserInfo,
      IndusindMinKycUserUpdateSuccess: _IndusindMinKycUserUpdateSuccess,
      UserDetails: _UserDetails,
    } = this.props;
    const {
      history,
      IndusindMinKycUserInfo,
      IndusindMinKycUserInfo: {
        data: {
          client_kyc_upload = {},
        } = {},
        status = false,
      } = {},
      IndusindMinKycUserUpdateSuccess, IndusindMinKycUserUpdateSuccess: { status: updateStatus },
      onInitUpdatedUserProfile,
      UserDetails,
      UserDetails: {
        indusind_min_kyc_required = false,
      } = {},
    } = nextProps;
    if (!utils.isEqual(IndusindMinKycUserUpdateSuccess, _IndusindMinKycUserUpdateSuccess) && updateStatus) {
      onInitUpdatedUserProfile();
    } else if (!utils.isEqual(UserDetails, _UserDetails) && !indusind_min_kyc_required) {
      utils.forceRedirect(history, { pathname: constants.LINK_PAY_BALANCE });
    } else if (!utils.isEqual(IndusindMinKycUserInfo, _IndusindMinKycUserInfo) && status) {
      this.setState({ formValues:
        {
          personalDetails: client_kyc_upload || {},
        },
      });
    }
    return '';
  }

  componentWillUnmount() {
    const { onResetIndusindMinKycUserInfo } = this.props;
    onResetIndusindMinKycUserInfo({});
  }

  render() {
    const {
      formValues,
    } = this.state;
    const {
      onInitIndusindMinKycCities,
      MinKycUserDetails,
      onGenerateYscOtp,
      GenerateOtpIndusInd,
      onGetOtpSuccess,
      onResetPopup,
      onOtpCaptureAction,
      OtpSubmitResponse,
      onDedupeVerify,
      DedupeVerifySuccess,
      history,
      onInitUpdatedUserProfile,
      UserDetails,
      isLoadingStatus,
      isLoading,
    } = this.props;
    return (
      <StyledIndusindMinKyc>
        <Container>
          <ZaggleCard>
            <Row align="middle" type="flex" gutter={24} className="margin-t-2">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h2>Manage Zaggle Cards</h2>
                <Breadcrumb separator="<" className="margin-b-2 font-12 custom-breadcrumb">
                  <Breadcrumb.Item href={constants.LINK_MY_PROFILE} className="crumb-link">My Account</Breadcrumb.Item>
                  <Breadcrumb.Item href={constants.LINK_PAY_BALANCE} className="crumb-link">Manage Cards</Breadcrumb.Item>
                  <Breadcrumb.Item>Min Kyc</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
            <Card className="rounded noborder noshadow">
              <Row align="top" type="flex" justify="start" gutter={20}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className="margin-t-3">
                  <PersonalAddressForm
                    history={history}
                    formValues={formValues}
                    onInitIndusindMinKycCities={onInitIndusindMinKycCities}
                    MinKycUserDetails={MinKycUserDetails}
                    onGenerateYscOtp={onGenerateYscOtp}
                    GenerateOtpIndusInd={GenerateOtpIndusInd}
                    onGetOtpSuccess={onGetOtpSuccess}
                    onResetPopup={onResetPopup}
                    onOtpCaptureAction={onOtpCaptureAction}
                    OtpSubmitResponse={OtpSubmitResponse}
                    onDedupeVerify={onDedupeVerify}
                    DedupeVerifySuccess={DedupeVerifySuccess}
                    onInitUpdatedUserProfile={onInitUpdatedUserProfile}
                    UserDetails={UserDetails}
                    isLoadingStatus={isLoadingStatus}
                    isLoading={isLoading}
                  />
                </Col>
              </Row>
            </Card>
          </ZaggleCard>
        </Container>
      </StyledIndusindMinKyc>
    );
  }
}

IndusindMinKyc.propTypes = IndusindMinKycProps;

const IndusindMinKycWrapper = Form.create({ name: 'normal_admin' })(IndusindMinKyc);
const component = connect(IndusindMinKycmapStateToProps, IndusindMinKycDispatchToProps)(AppWrappperHOC(IndusindMinKycWrapper));
export { IndusindMinKyc, IndusindMinKycWrapper };
export default component;




// WEBPACK FOOTER //
// client/containers/IndusindMinKyc/index.js